import React from 'react';
import { motion } from 'framer-motion';

const steps = [
  {
    emoji: "🧱",
    title: "Création de votre programme",
    description:
      "Nous transformons vos contenus RH en un module d'accueil personnalisé pour vos candidats.",
  },
  {
    emoji: "📝",
    title: "Ouverture des recrutements",
    description:
      "On co-construit une fiche de poste ultra-précise qui servira de base au ciblage.",
  },
  {
    emoji: "🎯",
    title: "Sourcing intelligent",
    description:
      "Nos experts activent réseau, annonces, CVthèques et Ads selon vos contraintes.",
  },
  {
    emoji: "🔍",
    title: "Préqualification rigoureuse",
    description:
      "Chaque profil passe par notre filtre humain + tech pour valider l'adéquation poste.",
  },
  {
    emoji: "🧪",
    title: "Test de personnalité",
    description:
      "Les candidats réalisent un test Trimoji. Objectif : évaluer le matching et préparer l'intégration.",
  },
  {
    emoji: "📞",
    title: "Entretien consultant",
    description:
      "Un de nos experts RH valide le profil à l'oral avant transmission.",
  },
  {
    emoji: "🧑‍💼",
    title: "Entretien client",
    description:
      "Vous reprenez la main avec toutes les cartes en main : analyse + feedback RH.",
  },
  {
    emoji: "🚀",
    title: "Préboarding personnalisé",
    description:
      "Le candidat accède à votre parcours d'intégration digitalisé, conçu sur mesure.",
  },
  {
    emoji: "💬",
    title: "Rapport d'étonnement",
    description:
      "Au bout d'un mois, il vous livre ses ressentis pour ajuster votre culture et onboarding.",
  },
];

const RecruitmentTimeline = () => {
  return (
    <div className="relative py-24 px-6 bg-neutral-50">
      <h2 className="text-4xl md:text-5xl font-bold text-center mb-16 text-neutral-900">
        🏁 Vos recrutements, 
        <br className="md:hidden" /> 
        étape par étape
      </h2>

      <div className="relative border-l-4 border-neutral-300 ml-6 md:ml-1 max-w-5xl mx-auto">
        {steps.map((step, index) => {
          const isLeft = index % 2 === 0;
          return (
            <motion.div
              key={index}
              className={`relative mb-20 flex flex-col md:flex-row items-start md:items-center md:justify-${isLeft ? 'start' : 'end'}`}
              initial={{ opacity: 0, x: isLeft ? -50 : 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
            >
              <div
                className="absolute w-10 h-10 bg-white rounded-full border-4 border-primary flex items-center justify-center text-2xl font-bold text-primary shadow-lg z-10"
                style={{ left: '-30px' }}
              >
                {step.emoji}
              </div>

              <div className={`w-full md:w-1/2 p-6 rounded-xl bg-white shadow-xl transition-all duration-300 hover:shadow-2xl ${isLeft ? 'ml-12 md:mr-auto' : 'ml-auto md:ml-12'}`}>
                <h3 className="text-xl font-bold mb-2 text-neutral-900">{step.title}</h3>
                <p className="text-neutral-700 text-base leading-relaxed">{step.description}</p>
              </div>
            </motion.div>
          );
        })}
      </div>
    </div>
  );
};

export default RecruitmentTimeline;